import { API_URL } from "./config";

export interface PlayerRow {
  uuid: string;
  current_name: string;
  avatar_url?: string | null;
  team_name?: string | null;
  team_slug?: string | null;
  accent_color?: string | null;
  rank?: number;
  points: number;
  kills: number;
  assists: number;
  deaths: number;
  wins: number;
  losses: number;
  games_played: number;
  events_played?: number;
  mvps: number;
  kd: number;
  kda: number;
  win_rate: number;
}

export interface Page<T> {
  data: T;
  meta: { page?: number; limit?: number; total?: number; requestId: string };
}

export async function apiGet<T>(path: string, signal?: AbortSignal): Promise<Page<T>> {
  const init: RequestInit = { headers: { Accept: "application/json" } };
  if (signal) init.signal = signal;
  const response = await fetch(`${API_URL}${path}`, init);
  const contentType = response.headers.get("Content-Type") ?? "";
  if (!contentType.includes("application/json")) {
    throw new Error(`La API no devolvio JSON para ${path}. Revisa VITE_PUBLIC_API_URL.`);
  }
  const payload = await response.json() as { success: boolean; data?: T; meta?: Page<T>["meta"]; error?: { message: string } };
  if (!response.ok || !payload.success) throw new Error(payload.error?.message ?? "No se pudo cargar la informacion.");
  return { data: payload.data as T, meta: payload.meta ?? { requestId: "unknown" } };
}

export function qs(params: Record<string, string | number | undefined | null>): string {
  const url = new URLSearchParams();
  for (const [key, value] of Object.entries(params)) {
    if (value !== undefined && value !== null && value !== "") url.set(key, String(value));
  }
  const text = url.toString();
  return text ? `?${text}` : "";
}

export function avatarUrl(player: Pick<PlayerRow, "uuid" | "avatar_url">): string {
  return player.avatar_url || minecraftAvatarUrl(player.uuid);
}

export function minecraftAvatarUrl(uuidOrName: string, size = 128): string {
  return `https://mc-heads.net/avatar/${encodeURIComponent(uuidOrName)}/${size}`;
}
